import { accountActivationFeature } from './account-activation.reducer';

export const {
  selectUsername,
  selectActivationToken,
  selectTokenType,
  selectNextStep,
  selectLoginMethod,
  selectExpiresIn,
  selectExpiresAt,
  selectMessage,
  selectTempSessionToken,
  selectCanGoToStep,
  selectError,
  selectLoading,
  selectAccountActivationState,
} = accountActivationFeature;
